<mf-page title="Editar plantilla de correo">
  @if (templateEmailDto) {
    <mf-template
      [templateDto]="templateEmailDto"
      (save)="save($event)"
      (closeButtonClick)="close()" />
  }
</mf-page>
